import { useCallback } from 'react';
import { usePrefsStore } from '@/lib/prefs/usePrefsStore';
import { translate } from './translations';

/**
 * Translation hook. Subscribes to the language pref so React re-renders
 * components when the user switches languages.
 *
 *   const t = useT();
 *   <h1>{t('dashboard.subBrands')}</h1>
 *
 * Interpolation — pass a vars dict to substitute `{name}` placeholders:
 *
 *   t('otp.resendIn', { seconds: 12 })   // "Resend in 12s"
 *
 * Unknown keys fall back to the key string, making it safe to ship
 * translations incrementally.
 */
export function useT() {
  const language = usePrefsStore((s) => s.language);
  return useCallback(
    (key: string, vars?: Record<string, string | number>) => {
      let out = translate(language, key);
      if (vars) {
        for (const k of Object.keys(vars)) {
          out = out.replace(new RegExp(`\\{${k}\\}`, 'g'), String(vars[k]));
        }
      }
      return out;
    },
    [language],
  );
}
